import { memo, useReducer } from "react";
import { StateProp } from "../types"
import { initial_sidebar, sidebarReducer } from "./reducer";
import SidebarContext from "./context";

const SidebarState = memo(({ children }: StateProp) => {
  const [sidebar, dispatch] = useReducer(sidebarReducer, initial_sidebar)

  return (
    <SidebarContext.Provider value={{ sidebar, dispatch }}>
      {children}
    </SidebarContext.Provider>
  )
})

export default SidebarState
